import { type FC } from 'react'
import { observer } from 'mobx-react-lite'
import { Icon, SpinnerLoader, Typography } from 'shared/ui'
import styles from 'widgets/RecordVideo/ui/styles.module.scss'
import { VideoRecord } from 'widgets/RecordVideo/ui/video/VideoRecord'
import { StreamRecord } from 'widgets/RecordVideo/ui/video/StreamRecord'
import type { RecordStore } from 'widgets/Record'

type IVideoContentProps = {
  recordStore: RecordStore
}

export const VideoContent: FC<IVideoContentProps> = observer(({ recordStore }) => {
  const { stream, loading, pauseRecord } = recordStore
  if (loading) {
    return (
      <div className={styles.loading}>
        <SpinnerLoader ariaLabel={'VideoContent'} size={24} />
      </div>
    )
  }
  if (!stream) {
    return (
      <div className={styles.empty}>
        <Icon icon={'cameraOff'} fontSize={24} />
        <Typography variant={'body-lg-medium'} ariaLabel={'camera'}>
          No camera found
        </Typography>
      </div>
    )
  }
  return pauseRecord ? (
    <VideoRecord recordStore={recordStore} />
  ) : (
    <StreamRecord recordStore={recordStore} />
  )
})
